<template>
  <button
    class="k-selection-button"
    :class="classes"
    :disabled="button.disabled"
  >
    <k-icon
      :icon="button.icon"
      class="icon"
    />
    <span class="name">
      {{button.name}}
    </span>
  </button>
</template>

<script>
import KIcon from './KIcon.vue'

export default {
  name: 'KSelectionButton',
  props: {
    button: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    KIcon
  },
  computed: {
    classes () {
      let defaultClasses = ''
      if (this.button.disabled) defaultClasses += ' -disabled'
      if (this.button.selected) defaultClasses += ' -selected'

      return defaultClasses
    }
  }
};
</script>

<style lang='scss' scoped>
@import "@/assets/scss/main.scss";;

.k-selection-button {
  color: rgba($neutral-1, 0.8);
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  @include body-1;
  border: 2px solid rgba(18, 30, 72, 0.2);
  border-radius: 27px;
  width: fit-content;
  max-width: 300px;
  padding: $spacing-s;
  cursor: pointer;
  transition: all ease 0.3s;
  outline: $primary-1;
  .icon {
    font-size: 24px;
  }
  .name {
    padding-left: $spacing-xs;
  }
  &:hover,
  &.-selected {
    border-color: $primary-1;
  }
  &.-selected {
    background: rgba(0, 178, 227, 0.08);
  }
  &:disabled {
    background: rgba(32, 41, 80, 0.09);
    color: rgba($neutral-1, 0.4);
    cursor: not-allowed;
    &:hover {
      border-color: rgba(18, 30, 72, 0.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KSelectionButton.vue